import {
  GET_LABTEST,
  GET_LABTEST_FAIL,
  GET_LABTEST_SUCCESS,
  GET_LABTESTS,
  GET_LABTESTS_FAIL,
  GET_LABTESTS_SUCCESS,
  ADD_NEW_LABTEST,
  ADD_LABTEST_SUCCESS,
  ADD_LABTEST_FAIL,
  UPDATE_LABTEST,
  UPDATE_LABTEST_SUCCESS,
  UPDATE_LABTEST_FAIL,
  DELETE_LABTEST,
  DELETE_LABTEST_SUCCESS,
  DELETE_LABTEST_FAIL,
  SET_STATE_LABTEST,
  GET_LABTESTSSAMPLES,
  GET_LABTESTSSAMPLES_FAIL,
  GET_LABTESTSSAMPLES_SUCCESS,
  UPDATE_LABTEST_STATUS
} from "./actionTypes"

export const setState = ( loading ) => ({
  type: SET_STATE_LABTEST,
  payload: loading,
})

export const getLabTests = ( params ) => ({
  type: GET_LABTESTS,
  payload: { params },
})

export const getLabTestsSuccess = (labTests, totalPages, currentPage) => ({
  type: GET_LABTESTS_SUCCESS,
  payload: { labTests:labTests, total:totalPages, currentPage:currentPage}
})

export const getLabTestsFail = error => ({
  type: GET_LABTESTS_FAIL,
  payload: error,
})

export const getLabTestSamples = ( params ) => ({
  type: GET_LABTESTSSAMPLES,
  payload: { params },
})

export const getLabTestsSamplesSuccess = (id, labTestsSamples) => ({
  type: GET_LABTESTSSAMPLES_SUCCESS,
  payload: { labTestsSamples:labTestsSamples, id:id }
})

export const getLabTestsSamplesFail = error => ({
  type: GET_LABTESTSSAMPLES_FAIL,
  payload: error,
})


export const addNewLabTest = labTest => ({
  type: ADD_NEW_LABTEST,
  payload: labTest,
})

export const addLabTestSuccess = labTest => ({
  type: ADD_LABTEST_SUCCESS,
  payload: labTest,
})  

export const addLabTestFail = error => ({
  type: ADD_LABTEST_FAIL,
  payload: error,
})

export const updateLabTest = labTest => ({
  type: UPDATE_LABTEST,
  payload: labTest,
})

export const updateLabTestStatus = labTest => ({
  type: UPDATE_LABTEST_STATUS,
  payload: labTest,
})

export const updateLabTestSuccess = labTest => ({
  type: UPDATE_LABTEST_SUCCESS,
  payload: labTest,
})

export const updateLabTestFail = error => ({
  type: UPDATE_LABTEST_FAIL,
  payload: error,
})

export const deleteLabTest = labTest => ({
  type: DELETE_LABTEST,
  payload: labTest,
})

export const deleteLabTestSuccess = id => ({
  type: DELETE_LABTEST_SUCCESS,
  id,
})

export const deleteLabTestFail = error => ({
  type: DELETE_LABTEST_FAIL,
  payload: error,
})

export const getLabTest = () => ({
  type: GET_LABTEST,
})

export const getLabTestSuccess = labTest => ({
  type: GET_LABTEST_SUCCESS,
  payload: labTest,
})

export const getLabTestFail = error => ({
  type: GET_LABTEST_FAIL,
  payload: error,
})
